module.exports = __webpack_public_path__ + "static/media/add-widget-button-white.b4a98cf2.svg";